export const getSubtotalItem = (
  discount: number,
  price_reject: number,
  quantity_reject: number
): number => {
  // Vars
  const subtotal = quantity_reject * price_reject

  return subtotal - (subtotal * discount / 100)
}
